module.exports = __webpack_public_path__ + "images/edges@3x.png?7003f288";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/edges@3x.png
// module id = 617
// module chunks = 7